import { useEffect, useState } from "react";

import { Button, InputAdornment, TextField, Typography } from "@mui/material";
import classNames from "classnames";
import { IoSync } from "react-icons/io5";
import { useNavigate, useParams } from "react-router-dom";

import { MAX_COURSE_NAME_LENGTH } from "../../../../../constants";
import { useMyCourseInstructor } from "../../hooks/useMyCourseInstructor";

export function MyCourseName() {
	const { course, updateCourseBasicInformation } = useMyCourseInstructor();
	const [name, setName] = useState(course?.name ?? "");
	const [nameError, setNameError] = useState("");
	const navigate = useNavigate();
	const params = useParams();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (course?.courseSlug && params.slug !== course.courseSlug) {
			navigate(`/my-services/${course.courseSlug}/description`, {
				replace: true,
			});
		}
	}, [course?.courseSlug, navigate, params.slug]);

	if (!course) {
		return null;
	}

	const onClickCancel = () => {
		setName(course.name);
	};

	const onClickUpdate = async () => {
		if (name.trim() === course.name.trim() || name.trim() === "") {
			return;
		}

		setLoading(true);
		await updateCourseBasicInformation({ name: name.trim() });
		setLoading(false);
	};

	const isDisabled =
		name.trim() === course.name.trim() || name.trim() === "" || loading;
	const isEdited = name !== course.name && !loading;

	return (
		<>
			<div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
				<Typography className="small-title-text bold">
					2. Narrow it down into a tagline
				</Typography>
				{loading && (
					<div>
						<IoSync className="normal-icon rotation-icon blue-icon" />
					</div>
				)}
			</div>
			<Typography className="normal-text">
				Tip: Finish the sentence 'Imagine you could do...'
			</Typography>
			<div className="common-input">
				<TextField
					size="small"
					autoComplete="off"
					id="course-name"
					onChange={(e) => {
						setName(e.target.value.slice(0, MAX_COURSE_NAME_LENGTH));
						if (e.target.value.trim() === "") {
							setNameError("Dream come true");
						} else {
							setNameError("");
						}
					}}
					className={classNames("item-separator-small", {
						invalid: !!nameError,
					})}
					value={name}
					fullWidth
					placeholder="What is the outcome your students aspire to?"
					slotProps={{
						input: {
							className: "normal-text",
							classes: {
								input: "input-placeholder",
							},
							endAdornment: (
								<InputAdornment position="end">
									<Typography className="normal-text">{`${name.length}/${MAX_COURSE_NAME_LENGTH}`}</Typography>
								</InputAdornment>
							),
						},
					}}
				/>
				{nameError && (
					<Typography className="small-text invalid-message">
						{nameError}
					</Typography>
				)}
			</div>
			<div className="button-container item-separator-small">
				<Button
					className="normal-button disabled-button"
					disabled={!isEdited}
					onClick={onClickCancel}>
					Cancel
				</Button>
				<Button
					disabled={isDisabled}
					className={classNames("normal-button", {
						"primary-button": !isDisabled,
						"disabled-button": isDisabled,
					})}
					onClick={onClickUpdate}>
					Save
				</Button>
			</div>
		</>
	);
}
